export default __webpack_public_path__ + "static/media/3.b519b5b1.png";